export const routesTelefonRehberi = [
  {
    path: "/telefon-rehberi",
    name: "telefon_rehberi",
    component: () => import("@/views/telefon_rehberi/Index.vue"),
    meta: {
      public: false,
      title: "telefon_rehberi.TelefonRehberi",
      yetki: { k: [1170002] },
    },
  },
]
